import { render } from "./layerPage.vue?vue&type=template&id=38e83660&scoped=true"
import script from "./layerPage.vue?vue&type=script&lang=js"
export * from "./layerPage.vue?vue&type=script&lang=js"

import "./layerPage.vue?vue&type=style&index=0&id=38e83660&lang=scss"
import "./layerPage.vue?vue&type=style&index=1&id=38e83660&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e83660"]])

export default __exports__